// src/pages/termOfPayments/CreateTermOfPayments.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditTermOfPayments from "../../components/termOfPayments/FormAddEditTermOfPayments";

const CreateTermOfPayments = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditTermOfPayments
                isEdit={false}
                onSubmitSuccess={() => navigate("/term-of-payments")}
            />
        </WrapperSection>
    );
};

export default CreateTermOfPayments;